<template>
  <wizard-form v-on="$listeners" v-bind="$attrs">
    <template #content>
      <v-row>
        <v-col cols="12">
          <h1 class="primary--text font-weight-medium py-0">
            {{ $t('transfer_request_select_instruction') }}
          </h1>
        </v-col>
        <v-col cols="12" class="py-0">
          <ValidationProvider
            :name="$t('transfer_request_instruction')"
            rules="required"
            v-slot="{ errors }"
          >
            <BaseList
              flat
              color="primary"
              :headers="headers"
              :items="instructions"
              :loading="loading"
              :totalRows="totalRows"
              :breadcrumbs="false"
              :elevation="0"
              show-select
              single-select
              v-model="permanentInstruction"
              item-key="transferInstructionId"
              :height="'100%'"
              :buttons="{search: false}"
              @refresh="getData"
              @options="handleOptions"
              :error-messages="errors"
              @item-selected="handlePermanentInstruction"
            >
              <template #header.alias>
                <span> {{$t('transfer_index_alias')}} </span>
              </template>
              <template #header.trType>
                <span> {{$t('transfer_index_type')}} </span>
              </template>
              <template #header.bnfBankName>
                <span> {{$t('transfer_index_bank')}} </span>
              </template>
              <template #header.status>
                <span> {{$t('transfer_index_status')}} </span>
              </template>
              <template #header.bankAccountNumber>
                <span> {{$t('transfer_index_account')}} </span>
              </template>
              <template #header.operation>
                <span> {{$t('transfer_index_action')}} </span>
              </template>
              <template #item.bnfBankName="{ item }">
                <span>{{ item.accountType == 'nfiAccount' ? item.nfiName : item.bnfBankName}}</span>
              </template>
              <template #item.status="{ item }">
                <span>{{ item.isCertified ? 'Certificada' : 'Debe Certificar'}}</span>
              </template>
              <template #item.bankAccountNumber="{ item }">
                <span>{{ item.accountType == 'nfiAccount' ? handleBankAccount(item.nfiAccountNumber, item.isCertified) : handleBankAccount(item.bnfBankAccNumber, item.isCertified)}}</span>
              </template>
              <template
                #item.data-table-select="{ select, isSelected, on, attrs }"
              >
                <v-simple-checkbox
                  off-icon="$radioOff"
                  on-icon="$radioOn"
                  :ripple="false"
                  v-bind="attrs"
                  v-on="on"
                  @click="select"
                  :value="isSelected"
                  :class="{ 'red-checkbox': errors[0] }"
                />
              </template>
              <template #item.isThirdParty="{ value }">
                <v-chip
                  small
                  :color="value ? 'primary' : 'default'"
                  class="text-capitalize px-5"
                >
                  {{ value ? $t('btn_yes') : $t('btn_no') }}
                </v-chip>
              </template>
            </BaseList>
            <span
              v-if="errors[0]"
              class="my-4 red--text"
            >
              {{ errors[0] }}
            </span>
          </ValidationProvider>
        </v-col>
      </v-row>
    </template>
  </wizard-form>
</template>
<script>
import WizardForm from '@/components/commons/WizardForm'
import ClientTransferInstructionsService from '@/services/clientTransferInstructions'
import BaseList from '@/components/commons/BaseList'
import { mapState } from 'vuex'

export default {
  components: {
    WizardForm,
    BaseList
  },
  props: {
    clientRequest: {
      type: Object,
      require: true
    }
  },
  data() {
    return {
      checkbox: false,
      instructions: [],
      loading: false,
      totalRows: 0,
      permanentInstruction: [],
      headers: [
        { text: 'Alias', value: 'alias' },
        { text: 'Tipo de Instrucción', value: 'trType' },
        { text: 'Institución Financiera', value: 'bnfBankName' },
        {
          text: 'payments_to_third_parties',
          value: 'isThirdParty',
          align: 'center',
          width: '5rem'
        },
        { text: 'Status', value: 'status' },
        {
          text: 'Número de Cuenta',
          value: 'bankAccountNumber',
          align: 'center'
        }
      ]
    }
  },
  computed: {
    ...mapState('account', ['account', 'accountData']),
    ...mapState('auth', ['user']),
    isExecutive() {
      return (
        this.user?.authorityLevelsCode === 1 ||
        this.user?.authorityLevelsCode === 2 ||
        this.user?.authorityLevelsCode === 4
      )
    },
    isAccountCode() {
      return (
        this.user?.avobjects?.findIndex(
          item =>
            item.code === this.account.code && item.typeCode === 'accountCode'
        ) > -1
      )
    }
  },
  async created() {
    await this.getData()
  },
  methods: {
    async getData() {
      this.loading = true
      try {
        this.instructions = await ClientTransferInstructionsService.find(
          this.account.code
        )

        this.totalRows = this.instructions.length
      } catch (error) {
        if (error.response.status !== 401)
          this.$dialog.message.error('No se pudo cargar la información.')
      } finally {
        this.loading = false
      }
    },
    handleOptions(options) {
      this.options = options
      this.getData()
    },
    handleBankAccount(acc, isCertified) {
      let account = isCertified ? acc : `...${acc.substring(acc.length - 4)}`
      return account
    },
    handlePermanentInstruction(event) {
      if (event.value) {
        this.$emit('selectInstruction', event.item)
      } else {
        this.$emit('clearInstruction')
      }
    }
  }
}
</script>
<style scoped>
.main-container {
  line-height: normal;
}

hr {
  margin: 0;
  padding: 0;
}

hr.rounded {
  border-top: 2px solid;
  width: 400px;
}

::v-deep .red-checkbox .v-icon {
  color: #F44336 !important;
}
</style>
